import CallUs from 'components/Content/CustomerService/CallUs/CallUs';
import { withCallUsProps } from 'viewModel/content/callUs/withCallUsProps';

export default withCallUsProps(CallUs);
